$ = jQuery

# responsible for providing a way to easily show a loading
# popup with a message as feedback while stuff loads
# - Ex: $.loading("Grabbing your content...")
$.extend jQuery,
  loading: (text) ->
    loadingIndicator = $('<span />').addClass('spinner')
    heading = $('<h1 />').addClass('modal-title').text(text)

    $.facebox($('<div />').addClass('loading-msg').html(heading.add(loadingIndicator)))

    spinner = new Spinner
      length: 5
      width: 2
      radius: 5
      color: '#222'

    spinner.spin(loadingIndicator.get(0))

# adds a 'glyph' icon to the error messages on forms
$.fn.addErrorIcon = ->
  $icon = $('<span />').addClass('flaticon solid exclamation-point-1')
  $(this).prepend($icon)

# prefills the timezone of a select input based on what
# Rails has available to choose from
$.fn.setTimezone = (railsTimezones) ->
  return $(this) unless window.jstz
  timezone = jstz.determine_timezone()
  $(this).val(railsTimezones[timezone.name()])

# ability to specify forms to submit via ajax
# - Ex: $('form.remote').submitWithAjax()
$.fn.submitWithAjax = (options) ->
  options ||= {}
  form = @

  form.submit (e) ->
    e.preventDefault()

    $(document).trigger('ajax:start')

    ajaxOptions =
      url: @action + ".js"
      type: options.type || 'POST'
      data: options.data || $(@).serialize()
      dataType: 'script'
      success: (response) ->
        $(document).trigger('ajax:success')
      error: (response) ->
        $(document).trigger('ajax:failure', response.responseText)
      complete: ->
        if form.data('disable-on-submit')
          # re-enable disabled submit button after ajax request is completed (success or failure)
          form
            .find('input.submit').add('button.submit').add('input[type=submit]').add('button[type=submit]')
            .prop('disabled', false)

    $.ajax ajaxOptions
